import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import _ from 'lodash';
import { Button, Card, Table } from 'semantic-ui-react';
import EditButton from './edit-button';
import SocialRatesFields from './social-rates-fields';

const InfluencerRatesTable = ({
  editing,
  facebook,
  facebookCount,
  facebookRates,
  instagram,
  instagramCount,
  instagramRates,
  twitter,
  twitterCount,
  twitterRates,
  youtubeChannelTitle,
  youtubeCount,
  youtubeRates,
  tiktok,
  tiktokCount,
  tiktokRates,
  twitch,
  twitchCount,
  twitchRates,
  snapchat,
  snapchatRates,
  telegram,
  telegramRates,

  currency,
  onEdit,
  onCancel,
  onSave,
  onChange,
  othersRates,
}) => {
  const socialRatesFieldsSharedProps = {
    readOnly: !editing,
    currency,
    onChange,
  };

  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>
          Rate Card
        </Card.Header>
      </Card.Content>
      <Card.Content>
        <Table textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign="left" >Social Network</Table.HeaderCell>
              <Table.HeaderCell>Followers</Table.HeaderCell>
              <Table.HeaderCell>Image ({currency})</Table.HeaderCell>
              <Table.HeaderCell>Video ({currency})</Table.HeaderCell>
              <Table.HeaderCell>Story ({currency})</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <SocialRatesFields
              value={facebook}
              network="facebook"
              followers={facebookCount}
              rates={facebookRates}
              {...socialRatesFieldsSharedProps}
            />
            <SocialRatesFields
              value={instagram}
              network="instagram"
              followers={instagramCount}
              rates={instagramRates}
              {...socialRatesFieldsSharedProps}
            />
            <SocialRatesFields
              value={twitter}
              network="twitter"
              followers={twitterCount}
              rates={twitterRates}
              {...socialRatesFieldsSharedProps}
            />
            <SocialRatesFields
              value={youtubeChannelTitle}
              network="youtube"
              followers={youtubeCount}
              rates={youtubeRates}
              {...socialRatesFieldsSharedProps}
            />
            <SocialRatesFields
              value={tiktok}
              network="tiktok"
              followers={tiktokCount}
              rates={tiktokRates}
              {...socialRatesFieldsSharedProps}
            />
            <SocialRatesFields
              value={twitch}
              network="twitch"
              followers={twitchCount}
              rates={twitchRates}
              {...socialRatesFieldsSharedProps}
            />
            <SocialRatesFields
              value={snapchat}
              network="snapchat"
              rates={snapchatRates}
              {...socialRatesFieldsSharedProps}
            />
            <SocialRatesFields
              value={telegram}
              network="telegram"
              rates={telegramRates}
              {...socialRatesFieldsSharedProps}
            />
            <SocialRatesFields
              value="others"
              network="others"
              rates={othersRates}
              {...socialRatesFieldsSharedProps}
            />

            {editing
              ? <Table.Row>
                <Table.Cell colSpan={2}>
                  <div className="spacer small" />
                  <Button size="medium" basic fluid onClick={onCancel}>Cancel</Button>
                </Table.Cell>
                <Table.Cell colSpan={4}>
                  <div className="spacer small" />
                  <Button
                    size="medium"
                    fluid
                    color="pink"
                    onClick={onSave}
                  >
                      Save Changes
                  </Button>
                </Table.Cell>
              </Table.Row>
              : <Table.Row>
                <Table.Cell colSpan={6}>
                  <div className="spacer small" />
                  <EditButton
                    content="Edit Post Rates"
                    onClick={onEdit}
                  />
                </Table.Cell>
              </Table.Row>}
          </Table.Body>
        </Table>
      </Card.Content>
      <Card.Content meta>
        {'The influencer rate currency is set in your '}
        <Link to="/team/manage">
        organisation settings
        </Link>
      </Card.Content>
    </Card>
  );
};

InfluencerRatesTable.propTypes = {
  editing: PropTypes.bool,
  facebook: PropTypes.string,
  facebookRates: PropTypes.object,
  instagram: PropTypes.string,
  instagramRates: PropTypes.object,
  twitter: PropTypes.string,
  twitterRates: PropTypes.object,
  youtube: PropTypes.string,
  youtubeRates: PropTypes.object,
  tiktok: PropTypes.string,
  tiktokRates: PropTypes.object,
  twitch: PropTypes.string,
  twitchRates: PropTypes.object,
  snapchat: PropTypes.string,
  snapchatRates: PropTypes.object,
  telegram: PropTypes.string,
  telegramRates: PropTypes.object,
  othersRates: PropTypes.object,

  currency: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};
InfluencerRatesTable.defaultProps = {
  editing: false,
  facebook: undefined,
  facebookRates: undefined,
  instagram: undefined,
  instagramRates: undefined,
  twitter: undefined,
  twitterRates: undefined,
  youtube: undefined,
  youtubeRates: undefined,
  tiktok: undefined,
  tiktokRates: undefined,
  twitch: undefined,
  twitchRates: undefined,
  snapchat: undefined,
  snapchatRates: undefined,
  telegram: undefined,
  telegramRates: undefined,
  others: undefined,
  othersRates: undefined,
};

export default InfluencerRatesTable;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-rates-table/influencer-rates-table.js
 **/